<template>
  <div>
    <div class="brand-logo">
      <BrandLogo
        name="Live Music Concert Brand"
        :logo="require('../../../assets/brands_logo_5_big.png')"
      ></BrandLogo>
    </div>
    <BrandIntro class="brand-intro" :lineArray="array" ></BrandIntro>
    <div class="products">
      <div class="products__block">
        <div class="products__block__title">Performance</div>
        <img
          class="products__block__img"
          src="../../../assets/brands_image_7.png"
        />
      </div>
    </div>
  </div>
</template>
<script>
import BrandLogo from "./BrandLogo";
import BrandIntro from "./BrandIntro"
export default {
  data() {
    return {
      array: [
          "ACO POP focuses on live pop music concerts and festivals featuring top Chinese, Korean and Japanese singers",
          "Rich resources of foreign performances",
          "In 2020, we will host over 100 middle and large -scale performances at indoor and outdoor stadiums.",
      ]
    };
  },
  components: {
    BrandLogo,
    BrandIntro
  }
};
</script>
<style lang="scss" scoped>
.brand-logo {
  padding: 64px 0 54px 0;
  text-align: center;
}
.brand-intro{
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}
.products {
  height: 867px;
  margin-top: 72px;
  background-color: #1f1f1f;
  overflow: hidden;
  &__block {
    &__title {
      color: #ec6900;
      text-align: center;
      font-size: 30px;
      font-weight: bold;
      font-size: 26px;
      margin-top: 58px;
    }
    &__img {
      display: block;
      margin: 31px auto 0 auto;
    }
  }
}
</style>